export default {
  setBusinessVariables(state, { data }) {
    state.businessVariables = data;
  },

  setSupportAvif(state, payload) {
    state.supportAvif = payload;
  },
};
